import { ROUTES } from 'routes/_definition';
import React from 'react';
import ArtistProfilePasswordChecker from 'stacks/ArtistProfileShowroom/views/ArtistProfileShowroomPassword';
import { getMatchRouteParams } from 'routes/routeUtils';

const ArtistHandleShowroomTitle: React.FC = () => {
  const {
    params: { artistHandle, title },
  } = getMatchRouteParams(ROUTES.ARTIST_HANDLE_SHOWROOM_TITLE);

  return <ArtistProfilePasswordChecker handle={artistHandle} title={title} />;
};

export default ArtistHandleShowroomTitle;
